import { create } from "zustand";
import { uuidv7 } from "@/lib/uuid";

export interface FailureEntry {
  id: string;
  mutation: "create" | "toggle" | "delete" | "ai" | "bulk" | "start" | "update";
  message: string;
  /** Absent when resending can only fail the same way, e.g. a validation error. */
  retry?: () => void;
  /** The retry button's label when it does something other than resend. */
  retryLabel?: string;
}

interface FailuresState {
  failures: FailureEntry[];
  pushFailure: (f: Omit<FailureEntry, "id">) => string;
  dismissFailure: (id: string) => void;
}

export const useFailures = create<FailuresState>()((set) => ({
  failures: [],

  pushFailure: (f) => {
    const id = uuidv7();
    set((s) => ({ failures: [...s.failures, { ...f, id }] }));
    return id;
  },

  dismissFailure: (id) =>
    set((s) => ({ failures: s.failures.filter((f) => f.id !== id) })),
}));
